import React, { useEffect } from "react";
import telecomBanner from "../../../main/assets/images/Images/Telecom/telecom-banner.png";
import telecombannermobile from "../../../main/assets/images/Images/Telecom/telecom_banner_mobile.png";
import telecom_benefit_1 from "../../../main/assets/images/Images/Telecom/telecom_benefit_1.png";
import telecom_benefit_2 from "../../../main/assets/images/Images/Telecom/telecom_benefit_2.png";
import telecom_benefit_3 from "../../../main/assets/images/Images/Telecom/telecom_benefit_3.png";
import telecom_benefit_4 from "../../../main/assets/images/Images/Telecom/telecom_benefit_4.png";
import dataDriven from "../../../main/assets/images/Icons/Telecom/datadriven.svg";
import demandForecasting from "../../../main/assets/images/Icons/Telecom/Outline-Icon.svg";
import enhancedOperational from "../../../main/assets/images/Icons/Telecom/enhanced.svg";
import increasedCustomer from "../../../main/assets/images/Icons/Telecom/loyalty.svg";
import scenarioModelling from "../../../main/assets/images/Icons/Telecom/Layer_1.svg";
import stayAhead from "../../../main/assets/images/Icons/Telecom/stay-ahead.svg";
import beFutureBg from "../../../main/assets/images/Images/Telecom/Be-future-read.svg";
import mobiletelecomfuture from "../../../main/assets/images/Images/Telecom/mobile_telecom_future.svg";
import mobiletelecomfuture1 from "../../../main/assets/images/Images/Telecom/telecomImg.png";
import infrastructureInvestment from "../../../main/assets/images/Images/Telecom/infrastructure-investment.png";
import preventiveMaintenance from "../../../main/assets/images/Images/Telecom/preventive-maintenance.png";
import serviceRollout from "../../../main/assets/images/Images/Telecom/service-rollout.png";
import group from "../../../main/assets/images/Icons/Telecom/group.svg";
import group1 from "../../../main/assets/images/Icons/Telecom/group1.svg";
import group2 from "../../../main/assets/images/Icons/Telecom/churn.png";
import group22 from "../../../main/assets/images/Icons/Telecom/whitechurn.png";
import group33 from "../../../main/assets/images/Icons/Telecom/Outline-Icon2.svg";
import group44 from "../../../main/assets/images/Icons/Telecom/Layer_11.svg";
import { Button } from "main/components/ui-components/Button";
import { MainPageHeader, SectionCard } from "main/components";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import SectionCardMobile from "main/components/componentsHelper/whtyantrapage/SectionCardMobile";

const featureTelecom = [
  {
    image: group,
    whiteIcon: group1,
    title: "Customer Experience Enhancement",
    subTitle:
      "Use predictive analysis to anticipate customer needs, address concerns proactively, and offer targeted solutions.",
  },
  {
    image: group2,
    whiteIcon: group22,
    title: "Churn Prediction",
    subTitle:
      "Analyze patterns to identify at-risk customers and develop retention strategies.",
  },
  {
    image: demandForecasting,
    whiteIcon: group33,
    title: "Demand Forecasting",
    subTitle:
      "Predict surges in demand to ensure optimal service during peak times.",
  },
  {
    image: scenarioModelling,
    whiteIcon: group44,
    title: "Scenario Modelling",
    subTitle:
      "Prepare for industry shifts by modeling potential changes in regulations, technology, or market demand.",
  },
];

const realWorldUseCases = [
  {
    image: serviceRollout,
    title: "Service Rollout",
    subTitle:
      "Forecast the demand for a new service, ensuring a smooth rollout without bandwidth issues.",
  },
  {
    image: preventiveMaintenance,
    title: "Preventive Maintenance",
    subTitle:
      "Predict potential network downtimes, enabling preemptive maintenance and ensuring uninterrupted service.",
  },
  {
    image: infrastructureInvestment,
    title: "Infrastructure Investment",
    subTitle:
      "By predicting future network usage trends, one can invest in infrastructure in high-demand areas, leading to improved service quality and customer satisfaction.",
  },
];

const benefits = [
  {
    image: enhancedOperational,
    mobileImage: telecom_benefit_1,
    title: "Enhanced Operational Efficiency",
    subTitle:
      "Streamline operations from network management to customer service, ensuring higher ROI.",
  },
  {
    image: dataDriven,
    mobileImage: telecom_benefit_2,
    title: "Data-Driven Decision Making",
    subTitle:
      "Make informed strategic decisions using insights drawn from a wealth of data.",
  },
  {
    image: increasedCustomer,
    mobileImage: telecom_benefit_3,
    title: "Increased Customer Loyalty",
    subTitle:
      "Offer tailored solutions and proactive service, boosting customer satisfaction and retention.",
  },
  {
    image: stayAhead,
    mobileImage: telecom_benefit_4,
    title: "Stay Ahead in Innovation",
    subTitle:
      "Embrace emerging telecom trends with confidence, backed by solid predictive insights.",
  },
];

export default function Telecom() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section>
        <MainPageHeader
          backgroundImage={telecomBanner}
          mobilebgImage={telecombannermobile}
          mainclassName="hx-450"
          HeaderClassName="text-color-success"
          heading={"Telecom"}
          descriptionClass="text-color-success mb-3"
          description={`In the fast-paced world of telecommunications, staying ahead means leveraging cutting-edge technology.`}
          subDescription={
            "Yantr.ai, a leading cognitive AI solution, offers the tools that today's telecom giants need to optimize operations and innovate services."
          }
          buttonGroup={
            <>
              <div className="d-block d-md-none">
                <Link to={"/contact-us"}>
                  <Button
                    textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                    className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                    text="Book a Demo"
                  />
                </Link>
              </div>
              <div className="d-none d-md-block">
                <Link to={"/contact-us"}>
                  <Button
                    textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                    className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                    text="Book a Demo"
                  />
                </Link>
              </div>
            </>
          }
        />
      </section>
      {/* mobile */}
      <div className="container-fluid d-block  d-md-none">
        <section className="container-fluid py-40 d-flex font-family-roboto flex-column align-items-center">
          <p className="dark-header fonts-800 font-30 mb-25 line-35 font-family-roboto text-align-center para-heading px-20">
            Features Tailored for Telecom
          </p>

          <Swiper
            slidesPerView={"auto"}
            spaceBetween={0}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper customSwiper"
          >
            {featureTelecom.map((val, index) => (
              <SwiperSlide className="p-10">
                <div className="col-md-12 col-sm-12 col-lg-12 p-10">
                  <Col key={index}>
                    <SectionCardMobile
                      classname="cards"
                      title={val.title}
                      icon={val.image}
                      whiteIcon={val.whiteIcon}
                      desc={val.subTitle}
                    />
                  </Col>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      </div>
      {/* website */}
      <div className="container d-none d-md-block">
        <section className="container pt-60 pb-50 d-flex font-family-roboto flex-column align-items-center">
          <p className="dark-header fonts-800 font-30 mb-25 line-35 font-family-roboto text-align-center para-heading">
            Features Tailored for Telecom
          </p>{" "}
          <div className="row cardsection px-mob-140">
            {featureTelecom.map((item: any, index: any) => {
              return (
                <div className="col-md-6 col-sm-12 col-lg-3 p-10">
                  <div
                    className={`tcard-container d-flex flex-column py-15 radius-10 justify-content-center align-items-center border border-1`}
                    key={index}
                  >
                    <div className="image-container">
                      <img
                        className="tfront-image mx-5 my-3 mt-4"
                        src={item?.image}
                        alt="background will be here"
                      />
                      <img
                        className="tback-image mx-5 mb-2"
                        src={item?.whiteIcon}
                        alt="background will be here"
                      />
                    </div>
                    <div className="card-body">
                      <p
                        className={`d-flex justify-content-center text-center card-title px-5 fonts-600 font-family-roboto font-24 line-26 pb-2`}
                        style={{ color: "#3D1187" }}
                      >
                        {item?.title}
                      </p>
                      <p
                        className="px-3 tcard-desc text-center text-white-color fonts-400 font-18 line-20 font-family-roboto"
                        style={{ color: "#3D1187" }}
                      >
                        {item?.subTitle}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
      <section className="py-60 footer font-family-roboto d-flex flex-column align-items-center">
        <p className="text-white-color fonts-800 font-30 mb-50 text-align-center line-35 font-family-roboto realworld">
          Real World Use Cases
        </p>

        <div className="row w-85 flex-gap-20 justify-content-between">
          {realWorldUseCases.map((item: any, index: any) => {
            return (
              <div
                key={index}
                className="real-world-view card-container1 flex-column w-30 mobile-cards-width d-flex px-16"
              >
                <img
                  src={item?.image}
                  className="img-br-8 "
                  alt="background will be here"
                />
                <p className="text-white-color font-family-roboto fonts-800 font-20 line-23 mt-3">
                  {item?.title}
                </p>
                <p className="text-white-color font-family-roboto fonts-400 font-16 line-20 mt-2 footer-subcontent2">
                  {item?.subTitle}
                </p>

                <div className="d-flex align-items-end h-100 mt-20 mb-10">
                  <Link to={"/contact-us"}>
                    <div className="d-none d-md-block">
                      {/* website */}
                      <Button
                        className="py-8 px-4 font-14 line-20 font-family-roboto fonts-500 text-white-color button-purple radius-10"
                        onClick={() => {}}
                      >
                        Explore
                      </Button>
                    </div>
                    <div className="d-block d-md-none pt-30">
                      <Button
                        className="py-8 px-4 font-14 line-20 font-family-roboto fonts-500 text-white-color button-purple radius-6"
                        onClick={() => {}}
                      >
                        Explore
                      </Button>
                    </div>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      {/* mobile */}
      <div className="container-fluid d-block  d-md-none">
        <section className="container-fluid py-40 d-flex font-family-roboto flex-column align-items-center">
          <p className="d-flex dark-header fonts-800 font-30 font-family-roboto mb-15 line-35 text-align-center mobile-contactus-heading">
            Benefits
          </p>
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={0}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper customSwiper"
          >
            {benefits.map((item: any, index: any) => (
              <div className="col-md-12 col-sm-12 col-lg-12">
                <div className="col">
                  <SwiperSlide className="p-10">
                    <div
                      key={index}
                      className="cards m-benefits-view flex-column d-flex align-items-center"
                    >
                      <img
                        className="mt-10 w-100 px-10"
                        src={item?.mobileImage}
                        alt="background will be here"
                      />
                      <div className="pt-2 d-flex flex-column align-items-center">
                        <p className="text-black-10 fonts-800 px-10 font-20 font-family-roboto line-24 align-items-center">
                          {item?.title}
                        </p>
                        <p className="px-20 text-grey fonts-400 font-16 mt-2 text-align-center line-20 font-family-roboto footer-subcontent2">
                          {item?.subTitle}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                </div>
              </div>
            ))}
          </Swiper>
        </section>
      </div>
      {/* Website */}
      <div className="d-none d-md-block">
        <section className="container py-60 d-flex font-family-roboto flex-column align-items-center">
          <p className="dark-header fonts-800 font-30 font-family-roboto mb-25 line-35 text-align-center mobile-contactus-heading">
            Benefits
          </p>

          <div className="row justify-content-between px-70 px-mob-140">
            {benefits.map((item: any, index: any) => {
              return (
                <div className="col-md-12 col-sm-12 col-lg-6 p-15">
                  <div
                    key={index}
                    className="benefits-view flex-column d-flex align-items-center"
                  >
                    <img
                      className="mt-10 w-100 px-10"
                      src={item?.image}
                      alt="background will be here"
                    />
                    <div className="mt-40 mb-40 d-flex flex-column align-items-center">
                      <p className="text-black-10 fonts-800 font-20 font-family-roboto line-24 align-items-center">
                        {item?.title}
                      </p>
                      <p className="px-20 text-grey fonts-400 font-16 mt-2 text-align-center line-20 font-family-roboto">
                        {item?.subTitle}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
      <div className="mx-20">
        <div className="radius-20 footer d-block  d-md-none">
          {/* mobile */}
          <section
            className="mb-40 py-4 py-md-0 radius-10"
            style={{
              backgroundImage: `url(${mobiletelecomfuture1})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              // height: "250px",
            }}
          >
            <div className="row py-0 py-md-5">
              <div className="col-lg-6 col-md-12"></div>
              <div className="col-lg-6 col-md-12 px-5 pt-400">
                <p className="text-white-color fonts-800 font-20 line-23 mb-10 pt-20 font-family-condensed">
                  Be Future-Ready with Yantr.ai
                </p>
                <p className="text-white-color fonts-400 font-13 font-family-condensed line-15 mb-30 ">
                  Elevate your telecom business with unparalleled insights and
                  optimization solutions.{" "}
                </p>
                <p className="text-white-color fonts-400 font-13 font-family-condensed line-15 mb-60">
                  Experience the Yantr.ai advantage today.
                </p>
                <div className="pb-40">
                  <Link to={"/contact-us"}>
                    <Button
                      textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                      className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                      text="Contact Us"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="container d-none d-md-block">
          {/* Website */}
          <section
            className="mb-60 py-3 py-md-0 radius-20"
            style={{
              backgroundImage: `url(${beFutureBg})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "350px",
            }}
          >
            <div className="row py-0 py-md-5">
              <div className="col-lg-6 col-md-12"></div>
              <div className="col-lg-6 col-md-12 px-5 p-20">
                <p className="text-white-color fonts-700 font-32 line-37 mb-10 pt-0 font-family-condensed mobile-contactus-heading">
                  Be Future-Ready with Yantr.ai
                </p>
                <p className="text-white-color fonts-400 font-20 font-family-condensed line-23 mb-10 mobile-contactus-subheading">
                  Elevate your telecom business with unparalleled insights and
                  optimization solutions.{" "}
                </p>
                <p className="text-white-color fonts-400 font-20 font-family-condensed line-23 mb-20 mobile-contactus-subheading">
                  Experience the Yantr.ai advantage today.
                </p>
                <Link to={"/contact-us"}>
                  <Button
                    className="py-12 px-4 font-16 fonts-500 text-white-color font-family-roboto-flex"
                    onClick={() => {}}
                  >
                    Contact Us
                  </Button>
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
